import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useCopy } from '@libs/hooks';
import { Checked, CopyIcon } from '../assets';
import { CopyButton, CustomTypography, ImgContainer } from './styles';
//  You should pass t("common_copy") as buttonTextBeforeCopying and t('common_copied') as buttonTextAfterCopying
const Copy = ({ text, buttonTextBeforeCopying, buttonTextAfterCopying, className, backgroundColor, shouldDisplayText = true, }) => {
    const { colors } = useTheme();
    const { isCounterRunning, handleCopy } = useCopy(text);
    const copyText = isCounterRunning
        ? buttonTextAfterCopying
        : buttonTextBeforeCopying;
    const textColor = isCounterRunning
        ? colors.text.interactive
        : colors.interactive.brandColor;
    return (_jsxs(CopyButton, { className: className, status: isCounterRunning, onClick: handleCopy, backgroundColor: backgroundColor, children: [shouldDisplayText && (_jsx(CustomTypography, { type: 'caption', fontFamily: 'primaryMedium', color: textColor, children: copyText })), _jsx(ImgContainer, { children: isCounterRunning ? (_jsx(Checked, { testId: "copyChecked", color: colors.text.interactive })) : (_jsx(CopyIcon, { testId: "copyIcon" })) })] }));
};
export default Copy;
//# sourceMappingURL=Copy.js.map